import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import CommonTitle from '../../../common-components/common-title';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const Tasks = () => {
    return (
        <ScrollAnimation delay={0} animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper isMargin={false} bigPaddings={true}>
                <CommonTitle>Задачи</CommonTitle>
                <div className="topdf-tasks__container">
                    <ul className="case__ol-list topdf-tasks__item">
                        <div className="topdf-tasks__item-img">
                            <img
                                src="/images/svg/topdf/topdf-tasks__item-img1.svg"
                                alt=""
                                loading="lazy"
                            />
                        </div>
                        <li className="common__ol-item" key={'index'}>
                            <span className="common__ol-number" style={{ color: '#c1272d' }}>
                                1.
                            </span>
                            <span className="common__ol-info">
                                Создать высоконагруженный сервис, который выдержит больше
                                10&nbsp;000&nbsp;000 посетителей в&nbsp;месяц.
                            </span>
                        </li>
                    </ul>

                    <ul className="case__ol-list topdf-tasks__item">
                        <div className="topdf-tasks__item-img">
                            <img
                                src="/images/svg/topdf/topdf-tasks__item-img2.svg"
                                alt=""
                                loading="lazy"
                            />
                        </div>
                        <li className="common__ol-item" key={'index'}>
                            <span className="common__ol-number" style={{ color: '#c1272d' }}>
                                2.
                            </span>
                            <span className="common__ol-info">
                                Выйти в&nbsp;ТОП-10 поисковых запросов в&nbsp;самой конкурентной
                                тематике, чтобы получить трафик, который распределяется между
                                лидерами на&nbsp;первой странице в&nbsp;поисковой выдаче.
                            </span>
                        </li>
                    </ul>

                    <ul className="case__ol-list topdf-tasks__item">
                        <div className="topdf-tasks__item-img">
                            <img
                                src="/images/svg/topdf/topdf-tasks__item-img3.svg"
                                alt=""
                                loading="lazy"
                            />
                        </div>
                        <li className="common__ol-item" key={'index'}>
                            <span className="common__ol-number" style={{ color: '#c1272d' }}>
                                3.
                            </span>
                            <span className="common__ol-info">
                                Создать для различных взаимодействий пользователей
                                с&nbsp;PDF-файлами в&nbsp;одном месте более 20&nbsp;микросервисов,
                                которые не&nbsp;предоставляют другие сервисы и&nbsp;приложения.
                            </span>
                        </li>
                    </ul>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Tasks;
